import { render, staticRenderFns } from "./AutomationPermissionSettings.vue?vue&type=template&id=6e9d46cf&scoped=true"
import script from "./AutomationPermissionSettings.vue?vue&type=script&lang=js"
export * from "./AutomationPermissionSettings.vue?vue&type=script&lang=js"
import style0 from "./AutomationPermissionSettings.vue?vue&type=style&index=0&id=6e9d46cf&prod&scoped=true&lang=scss"
import style1 from "./AutomationPermissionSettings.vue?vue&type=style&index=1&id=6e9d46cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9d46cf",
  null
  
)

export default component.exports